import { SYSTEM_NAME_ARRAY } from "../constants";

export function calcTotalAmount(value) {
  return Math.round(value * 0.15 * 4 * 10) / 10;
}

export function calcVseAmount(value) {
  return Math.round(value * 0.3 * 100) / 100;
}

export function calcCapacityRequired(waterHardnessValue, waterNeededValue) {
  return Math.round(waterHardnessValue * waterNeededValue * 10) / 10;
}

export function dotToComma(string) {
  return string.toString().replace(/\./g, ",");
}

export function getAverageWaterUsage(ekomValue, arrayToCompare) {
  if (ekomValue === SYSTEM_NAME_ARRAY[0]) {
    return arrayToCompare[0];
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[1]) {
    return arrayToCompare[1];
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[2]) {
    return arrayToCompare[2];
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[3]) {
    return arrayToCompare[3];
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[4]) {
    return arrayToCompare[4];
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[5]) {
    return arrayToCompare[5];
  } else {
    return "-";
  }
}

export function getAverageSaltUsage(ekomValue, arrayToCompare) {
  if (ekomValue === SYSTEM_NAME_ARRAY[0]) {
    return parseFloat(arrayToCompare[0]);
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[1]) {
    return parseFloat(arrayToCompare[1]);
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[2]) {
    return parseFloat(arrayToCompare[2]);
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[3]) {
    return parseFloat(arrayToCompare[3]);
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[4]) {
    return parseFloat(arrayToCompare[4]);
  }
  if (ekomValue === SYSTEM_NAME_ARRAY[5]) {
    return parseFloat(arrayToCompare[5]);
  } else {
    return "-";
  }
}

export function calcSavings(resourceUsageA, resourceUsageB) {
  return (
    parseFloat(resourceUsageA) -
    parseFloat(resourceUsageB)
  );
}

export function roundAndFixed(number) {
  // if(typeof number === 'NaN') {
  //   throw new Error('Not a number!');
  // }
  return Math.round(number).toFixed(2);
}